import React from 'react';
import { FormGroup, FormControl, Button } from 'react-bootstrap';
import Dropdown from 'react-dropdown';
import 'react-dropdown/style.css';
import ColorPicker from './ColorPicker';
import * as NumericInput from 'react-numeric-input';
import { injectIntl } from 'react-intl';

const itemsForDropdowns = {
    fonts: ['Give You Glory','Italiana','Kaufmann','Playlist Caps','Playlist Ornament','Playlist Script','Warnock Pro','Warnock Pro Display','Warnock Pro Caption'],
    fontWeights: ['normal', 'bold', 'italic', 'bold italic'],
    textAlignment: ['left', 'center', 'right'],
};

class TextComponent extends React.Component {
    getMenuItems = items => {
        return itemsForDropdowns[items];
    };

    render() {
        const { messages } = this.props.intl;
        return (
            <div className="react-avatar-right-column-text-container">
                <div className="react-avatar-right-column-text-wrapper row">
                    <FormGroup className="react-avatar-right-column-input col-md-12" >
                        <FormControl className="width100" onChange={this.props.onChangeText} value={this.props.text} placeholder={messages.enterCustomText} style={{ textAlign: "center",width:"100%" }}/>
                    </FormGroup>
                </div>
                <div className="react-avatar-right-column-options-wrapper row" style={{margin:"0"}}>
                    <label className="react-avatar-dropdown-with_label col-md-4">
                        {messages.font}
                        <Dropdown
                            className="width100"
                            onChange={this.props.selectFont}
                            id={this.props.font}
                            options={this.getMenuItems('fonts')}
                            value={this.props.font}
                        />
                    </label>
                    
                    <label className="react-avatar-dropdown-with_label col-md-3">
                        {messages.fontWeight}
                        <Dropdown
                            className="width100"
                            onChange={this.props.selectFontWeight}
                            id={this.props.font}
                            options={this.getMenuItems('fontWeights')}
                            value={this.props.fontWeight}
                        />
                    </label>

                    <label className="react-avatar-dropdown-with_label react-avatar-input-picker col-md-2">
                        {messages.size}
                        <NumericInput className="width100" onChange={this.props.selectSize} value={this.props.size} step={1} className="form-control" />
                    </label>
                    
                    <label className="react-avatar-dropdown-with_label col-md-3">
                        {messages.color}
                        <div
                            style={{
                                margin: '5px',
                                textAlign: 'center',
                            }}
                        >
                            <ColorPicker animation="slide-up" className="width100" color={this.props.color} onChange={this.props.selectColor} />
                        </div>
                    </label>

                    <label className="react-avatar-dropdown-with_label react-avatar-input-picker col-md-3">
                        {messages.rotation}
                        <NumericInput
                            className="width100"
                            max={360}
                            min={0}
                            onChange={this.props.selectRotation}
                            value={this.props.rotation}
                            step={1}
                            className="form-control "
                        />
                    </label>
                    </div>
                <div className="react-avatar-right-column-text-wrapper row" >
                <div class="float-right">
                    <Button onClick={this.props.removeText}  bsStyle="danger" className="react-avatar-remove-text-btn" style={{margin:"0 auto"}}>
                        {messages.removeText}
                    </Button>
                    </div>
                </div>
            </div>
        );
    }
}

export default injectIntl(TextComponent);



// WEBPACK FOOTER //
// ./src/Components/TextComponent.js